/* eslint-disable no-autofix/jsdoc/require-jsdoc */
import { getTsPharmacyClient } from '@montugroup/circuit-shared/api/pharmacy.client';
import getAuthBearerToken from '@montugroup/circuit-shared/utils/getAuthBearerToken';

const client = getTsPharmacyClient();
const { useQuery, keys } = client.listPharmacyReferrals;

type UseGetPharmacistEscriptsParams = {
  pageSize: number;
  after?: string;
  before?: string;
};

export function useGetPharmacistEscripts({ pageSize, after, before }: UseGetPharmacistEscriptsParams) {
  return useQuery({
    queryKey: [...keys, pageSize, after, before],
    queryData: {
      query: {
        page: {
          size: pageSize,
          after,
          before,
        },
      },
      headers: { authorization: getAuthBearerToken() },
    },
  });
}

export default useGetPharmacistEscripts;
